import { render, staticRenderFns } from "./CertificateConfigurator.vue?vue&type=template&id=0ac867b8&scoped=true"
import script from "./CertificateConfigurator.vue?vue&type=script&lang=js"
export * from "./CertificateConfigurator.vue?vue&type=script&lang=js"
import style0 from "./CertificateConfigurator.vue?vue&type=style&index=0&id=0ac867b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac867b8",
  null
  
)

export default component.exports